import React from "react";
import loading from "../../assets/img/icons/error.svg";

const ErrorMessage = ({
    handleClose,
    title="Request Failed!",
    details="Your message was not successfully sent. Please try again later."
    }) => {
  return (
    <div className='modal-message-successful'>
      <div className='wrapper'>
        <img src={loading} alt='Loading' />
        <div className='main-subtitle center primary-color large'>
          {title}
        </div>
        <p className='remove-br-mobile'>
          {details}
        </p>
        <button onClick={handleClose}>Close</button>
      </div>
    </div>
  );
};

export default ErrorMessage;
